import cloneDeep from 'lodash/cloneDeep'

import {
  GoalStatus,
  GoalType,
  GrowFollowersGoal,
} from 'shared/api/requests/aiEngagementGoal/schemas'

import { MessageEditorFormValues } from './types'

export const mapGoalToMessageFormValues = (goal: GrowFollowersGoal): MessageEditorFormValues => ({
  message: goal.data.message.text,
})

export const mergeMessageValuesWithGoal = (
  goal: GrowFollowersGoal,
  values: MessageEditorFormValues,
) => {
  const updatedGoal = cloneDeep(goal)

  updatedGoal.data.message.text = values.message

  return updatedGoal
}

export const createGoalFromFormValues = ({
  id,
  values,
}: {
  id: string
  values: MessageEditorFormValues
}): GrowFollowersGoal => ({
  id,
  status: GoalStatus.STOPPED,
  type: GoalType.GROW_FOLLOWERS,
  ts_updated: new Date().toISOString(),
  data: {
    message: {
      text: values.message,
    },
  },
})
